class GUID {
  static counter: number = 0;

  static create(prefix: string = ''): string {
    const time = new Date().getTime();
    const random = Math.random();

    GUID.counter++;

    // @ts-ignore
    return prefix + sha1(`${time}_${random}_${GUID.counter}`);
  }
}

export { GUID };
